import { useMemo } from 'react';
import { LABEL_WITH_COLOR, asDecoratorColor, decoratorColorToTrellisTokenMap } from 'customer-data-property-utils/optionDecoratorUtils';
import { usePropertyDefinition } from '../../v2/hooks/usePropertyDefinition';
import { useProperty } from '../../v2/hooks/useProperty';
export const decoratorColorToTagMap = {
  BLACK: 'pantera',
  GRAY: 'default',
  GREEN: 'green',
  GREEN_LIGHT: 'oz',
  YELLOW: 'yellow',
  YELLOW_LIGHT: 'marigold',
  RED: 'red',
  RED_LIGHT: 'candy-apple',
  TEAL: 'teal',
  TEAL_LIGHT: 'teal-light',
  BLUE: 'blue',
  BLUE_LIGHT: 'calypso',
  ORANGE: 'orange',
  ORANGE_LIGHT: 'lorax',
  PINK: 'magenta',
  PINK_LIGHT: 'norman',
  PURPLE: 'purple',
  PURPLE_LIGHT: 'thunderdome'
};
export const decoratorColorToBadgeMap = {
  BLACK: 'pantera',
  GRAY: 'koala',
  GREEN: 'oz',
  GREEN_LIGHT: 'green',
  YELLOW: 'marigold',
  YELLOW_LIGHT: 'yellow',
  RED: 'candy-apple',
  RED_LIGHT: 'red',
  TEAL: 'teal-dark',
  TEAL_LIGHT: 'teal',
  BLUE: 'calypso',
  BLUE_LIGHT: 'blue',
  ORANGE: 'lorax',
  ORANGE_LIGHT: 'orange',
  PINK: 'norman',
  PINK_LIGHT: 'magenta',
  PURPLE: 'thunderdome',
  PURPLE_LIGHT: 'purple'
};
const useOptionColors = () => {
  var _propertyDefinition$e, _propertyDefinition$e2;
  const property = useProperty();
  const {
    propertyDefinition,
    loading
  } = usePropertyDefinition({
    // only enumeration properties can have colors
    skip: property.type !== 'enumeration'
  });
  const optionDecoratorStyle = propertyDefinition === null || propertyDefinition === void 0 || (_propertyDefinition$e = propertyDefinition.extensionData) === null || _propertyDefinition$e === void 0 || (_propertyDefinition$e = _propertyDefinition$e.optionDecoratorsExtensionData) === null || _propertyDefinition$e === void 0 ? void 0 : _propertyDefinition$e.optionDecoratorStyle;

  // todo switch to constant
  const shouldUseBadgeDisplay = optionDecoratorStyle === 'LABEL_WITH_BADGE';
  const shouldUseOptionColors = optionDecoratorStyle === LABEL_WITH_COLOR || shouldUseBadgeDisplay;
  const optionDecorators = propertyDefinition === null || propertyDefinition === void 0 || (_propertyDefinition$e2 = propertyDefinition.extensionData) === null || _propertyDefinition$e2 === void 0 || (_propertyDefinition$e2 = _propertyDefinition$e2.optionDecoratorsExtensionData) === null || _propertyDefinition$e2 === void 0 ? void 0 : _propertyDefinition$e2.optionDecorators;
  const colorByOptionValue = useMemo(() => {
    if (!shouldUseOptionColors || !optionDecorators) {
      return {};
    }
    return Object.entries(optionDecorators).reduce((acc, [optionName, decorator]) => {
      const decoratorColor = asDecoratorColor(decorator.color);
      if (!decoratorColor) {
        return acc;
      }
      acc[optionName] = {
        trellisColor: decoratorColorToTrellisTokenMap[decoratorColor],
        tagColor: decoratorColorToTagMap[decoratorColor],
        badgeColor: decoratorColorToBadgeMap[decoratorColor]
      };
      return acc;
    }, {});
  }, [optionDecorators, shouldUseOptionColors]);
  return {
    colorByOptionValue,
    shouldUseOptionColors,
    shouldUseBadgeDisplay,
    loading
  };
};
export default useOptionColors;